import { db, storage } from '@/firebase.js';
export default({
    state:{
        galleryUploadList: [],
        currentImage: [],
        selectedCategory: '',
        totalFiles: 0,
        doneFiles: 0,
        uploading: false,
        categories: [],
        bindedItems: [],
        showBigImage: false,
        filesToCompress: [],
        error: [],
        compress: false,
        range: 0,
        message: ''
    },
    mutations:{
      getFiles(state, event){
        state.compress = true;
        event.target.files.forEach(file=>{
          state.filesToCompress.push(file);
        })
        state.filesToCompress.forEach(image=>{
          let reader = new FileReader();
          reader.readAsDataURL(image);
          let name = image.name;
          reader.onload = event =>{
            let img = new Image();
            img.src = event.target.result;
            img.onload = ()=>{
              let element = document.createElement('canvas');
              let width, height, scaleFactor;
              if(img.width > 1800){
              width = (img.width / 2);
              scaleFactor = width / img.width;
              height = img.height * scaleFactor;
              }
              else{
                width = img.width;
                height = img.height;
              }
              element.width = width;
              element.height = height;
              let ctx = element.getContext('2d');
              ctx.drawImage(img, 0, 0, width, height);
              ctx.canvas.toBlob(blob=>{
                 let file = new File([blob], name, {
                  type: 'image/jpeg',
                  lastModifiedL: Date.now()
                })
                state.galleryUploadList.push(file);
              }, 'image/jpeg', 0.70)
            }
            reader.onerror = error => state.error = error;
          }
        })
      },
      bindGalleryCategories(state){
        if(state.categories.length === 0){
        db.collection('galleryCategories').get().then(querySnapshot=>{
          querySnapshot.forEach(doc=>{
            let name = doc.data().name;
            let to = doc.data().to;
            let image = doc.data().image;
            state.categories.push({
              name, to, image
            })
          })
        })
      }
      },
      uploadFiles(state){
        state.uploading = true;
        state.totalFiles = state.galleryUploadList.length;
        if(state.selectedCategory !== ''){
        state.galleryUploadList.forEach(image=>{
            let storageRef = storage.ref(`${state.selectedCategory}/${image.name}`);
            storageRef.put(image)
            .then(snapshot=>{
                snapshot.ref.getDownloadURL().then(url=>{
                    db.collection(state.selectedCategory.toLowerCase()).doc().set({
                        name: image.name,
                        url,
                        selected: false,
                        range: state.range
                    })
                    state.doneFiles = state.doneFiles+1;
                })
            })
        })
        state.galleryUploadList = [];
        state.filesToCompress = [];
        state.uploading = false;
      }
    },
    bindGalleryItems(state, data){
      if(state.bindedItems !== []){
        state.bindedItems = [];
      }
      db.collection(data).orderBy('range').get().then(querySnapshot=>{
        querySnapshot.forEach(doc=>{
          let name = doc.data().name;
          let url = doc.data().url;
          let selected = doc.data().selected;
          let range = doc.data().range;
          state.bindedItems.push({
            name, url, selected, range
          })
        })
      })
    },
    selCat(state, element){
      if(element.target.value === 'Łoża sypialniane'){
        state.selectedCategory = 'lozasypialniane';
      }
      else{
      state.selectedCategory = element.target.value;
      }
    },
    bigImage(state, image){
      state.currentImage = image;
      state.showBigImage = !state.showBigImage;
    },
    selectRange(state, payload){
      state.range = payload.target.value;
    }
    },
    actions:{
      bindGalleryItems({commit}, data){
        commit('bindGalleryItems', data)
      },
    },
    getters:{}
})